import {
  useFreeTrialEligibilityRulesQuery,
  useFreeTrialProtectedQuery,
} from '@trello/graphql/generated';
import { idToDate, dateDifferenceInDays } from '@trello/dates';
import { OrganizationFeatures } from '@trello/product-features';

export const useFreeTrialEligibilityRules = (
  orgId?: string,
  options: { skip: boolean } = { skip: false },
) => {
  const {
    data: dataProtected,
    loading: loadingProtected,
  } = useFreeTrialProtectedQuery({
    fetchPolicy: 'network-only',
    variables: {
      orgId: orgId || '',
    },
    skip: options.skip,
  });

  const meId = dataProtected?.member?.id;

  const isMember = dataProtected?.organization?.memberships.find(
    (member) => member.idMember === meId,
  );

  const { data, loading } = useFreeTrialEligibilityRulesQuery({
    fetchPolicy: 'network-only',
    variables: {
      orgId: orgId || '',
    },
    skip: options.skip || !isMember,
  });

  const credits = data?.organization?.credits;
  const freeTrialCredit = credits && credits[0];

  let isTrialActive = false;
  if (freeTrialCredit) {
    const product =
      data?.organization?.products && data?.organization?.products[0];
    const hasBC = OrganizationFeatures.isBusinessClassProduct(product);
    const startDate = idToDate(freeTrialCredit?.id);
    const days = freeTrialCredit?.count;
    const expiresAt = startDate.setDate(startDate.getDate() + days);
    const daysLeft =
      expiresAt && dateDifferenceInDays(new Date(), new Date(expiresAt), true);
    isTrialActive = daysLeft > 0 && hasBC;
  }

  const isAdmin =
    meId &&
    !!data?.organization?.memberships.find(
      (member) => member.idMember === meId && member.memberType === 'admin',
    );

  return {
    isAdmin,
    isTrialActive,
    freeTrialCredit,
    hasFreeTrialCredit: !!freeTrialCredit,
    isEligible: isAdmin && !freeTrialCredit,
    loading: loading || loadingProtected,
  };
};
